import { render, staticRenderFns } from "./allAgentData.vue?vue&type=template&id=fb400f72&scoped=true&"
import script from "./allAgentData.vue?vue&type=script&lang=js&"
export * from "./allAgentData.vue?vue&type=script&lang=js&"
import style0 from "./allAgentData.vue?vue&type=style&index=0&id=fb400f72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb400f72",
  null
  
)

export default component.exports